import React from 'react';
import ReactDOM from 'react-dom/client'; // Correct import statement
import './index.css';
import App from './App';
import { CookiesProvider } from "react-cookie";
import reportWebVitals from './reportWebVitals';
import { ApolloProvider } from "@apollo/client";
import SetupApolloClient from "./apollo/apolloIndex";
import './translations/i18nest-config/i18next'
import { HelmetProvider } from 'react-helmet-async';
import { initAnalytics } from './utils/firebase/firebase';

initAnalytics();

function Main() {

  const client = SetupApolloClient();

  return (
    <React.StrictMode>
        <HelmetProvider>
          <CookiesProvider>
            <ApolloProvider client={client}>
                <App />
              </ApolloProvider>
          </CookiesProvider>
        </HelmetProvider>
    </React.StrictMode>
  );
}
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(<Main />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
